// see: https://developers.google.com/maps/faq#languagesupport
export enum GOOGLE_LANGUAGE_CODE {
  DE = 'de',
  CZ = 'cs',
  FR = 'fr',
  EN = 'en',
  VN = 'vi',
}
